import { Component, createRef } from "react";
import { connect } from "react-redux";
// import {change_header} from '../../../redux/actions/HeroBarAction'
import {set_datapage} from '@ora/recursos/src/redux/actions/DataPageAction'

import { Button, 
  Card, 

  Section, 
  Form,
   } from 'react-bulma-components';
import { baseUrl, localUrl } from "@ora/recursos/src/helpers/Url";
import axios from "axios";
import $ from 'jquery'
import dt from 'datatables.net'
import { Link, Redirect, useHistory } from "react-router-dom";
import { tagActivo } from "helpers/Datatables";
import Swal from "sweetalert2";
import InputsCreate from "layouts/mainsection/components/InputsCreate";



import {PageLength} from "helpers/Datatables";
$.DataTable = dt


class Viveros extends Component {
    state ={
        buscar : "",
        listaPaises : {data : []},
        listaTipo : {data : []},
    }

    
    filter = {
        buscar: '',
        WhereCondition : {
            'pai_int_id' : null,
            'emp_sts_registro' : null,
            'cites_empresas.var_int_id' : 2
        }
    }
    constructor(props){
        super(props)
        this.props.set_datapage({ titulo: 'Viveros',
        isbackend:false,
        breadcrumb:[
            {name:"Cites",url:"#"},
            {name:"Víveros",url:"#",active : true},
        ]});

        this.txtExportacion = createRef()
        this.slctPais = createRef()
        this.slctTipo = createRef()
    }

    componentDidMount () {
        this.init()

       $(this.txtExportacion.current).on('keyup',()=>{
           this.refrescarDT(this.txtExportacion.current.value, 'buscar')}
           )
        /*
         $(this.slctPaises.current).on('change',()=>{
            this.refrescarDTWhere(this.slctPaises.current.value, 'dar_txt_country')}
            )
        $(this.slctApendice.current).on('change',()=>{
            this.refrescarDTWhere(this.slctApendice.current.value, 'dar_txt_cite')}
            )
        $(this.slctUinc.current).on('change',()=>{
            this.refrescarDTWhere(this.slctUinc.current.value, 'dar_txt_uicn')}
            )
        */
        axios.get(baseUrl('cites/empresas/getColumnasEmpresas/pai_int_id')).then((res)=>{
            this.traerDataSelect(res.data, 'listaPaises')
        })
        axios.get(baseUrl('cites/empresas/getColumnasEmpresas/emp_sts_registro')).then((res)=>{
            this.traerDataSelect(res.data, 'listaTipo')
        })

    }

    traerDataSelect(data, columna){
        const listaSlct = data.map(item=>{
            return (<option value={item.columna}>{item.columna} </option>)
        })
        let dataSlct = {}
        dataSlct.data = listaSlct
        this.setState({[columna] : dataSlct})
    }

    refrescarDT(buscarValue, filtro){
        this.filter[filtro] = buscarValue
        this.datatable.draw()
    }

    refrescarDTWhere(buscarValue, columna){
        this.filter.WhereCondition[columna] = buscarValue
        this.datatable.draw()
    }
    
    init = () => {
        
        this.configDT =  {
            data: [],
            dom: "<'columns'<'column is-full'<'table-container't>>><'columns'<'column'l><'column'p>>",
            processing: true,
            pageLength:PageLength(),
            ajax: {
              url: baseUrl("cites/empresas/datatable"),
              data: (d) => {
                console.log('params buscar', this.state.buscar)
                d.filter = this.filter
                return d
              },
            },
            serverSide: true,
            order: [[0, "asc"]],
            createdRow: (r, d, i) => {
            },
            columns: [
              { data: "emp_int_id" },
              { data: "emp_txt_name" },
              { data: "pai_int_id", render : (d) =>{
                  return d ? d : "País no asignado"
              }},
              { data: "emp_txt_species", render: (d, t, r) => {
                let arr_o = JSON.parse(d) ? Object.values(JSON.parse(d)): [], result = ""
                if(arr_o.length>2)
                    arr_o.forEach((element, index) => {
                        if(index == arr_o.length - 1){
                            result += ", "+element
                        }
                        else{
                            result += element+", "
                        }
                    });
                else if(arr_o.length == 1){
                    result = arr_o[0]
                }
                else{
                    result = "sin especies"
                }
                return  result;
                
              } },
              { data: "emp_txt_species", render: (d, t, r) => {

                return  JSON.parse(d) ? Object.keys(JSON.parse(d)).length : 0;
                
              } }
            ],
            drawCallback: () => {
                $('#tblPaises_paginate a.previous').addClass("pagination-link pagination-previous");
                $('#tblPaises_paginate a.next').addClass("pagination-link pagination-next");
                $('#tblPaises_paginate a.next').addClass("pagination-link pagination-next");
                $('#tblPaises_paginate span a.paginate_button.current').addClass("pagination-link is-current");
                $('#tblPaises_paginate span a.paginate_button').addClass("pagination-link");
         
              }
        }
        this.table = $('#tblPaises')
        
        this.datatable = this.table.DataTable(this.configDT)
        


        
    }


    onSubmit_filter = (evt) => {
        evt.preventDefault()
        console.log(evt)
        this.filter.buscar = evt.target.elements.search.value
        this.datatable.draw()
        

    }

   



    render(){
        return(
        <div>
            <div className="columns mb-5">
                <div className="column">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer iaculis dui elit, vitae lobortis augue blandit vel. Donec tellus eros, 
                luctus ut enim a, dignissim lobortis ex. Quisque sit amet suscipit leo. Nullam finibus tincidunt mauris at gravida. 
                Curabitur varius eros urna, pellentesque consectetur felis accumsan et. Vivamus eget quam ornare, pulvinar nisi bibendum, 
                ullamcorper magna. In velit metus, suscipit id rutrum vitae, tempus sed magna. Integer ac turpis id lorem tincidunt consequat
                 nec quis sapien. Pellentesque id turpis at nulla congue congue. In venenatis blandit ante, ac vulputate est imperdiet sit amet. 
                 Pellentesque sit amet egestas urna, in iaculis massa. Donec volutpat lacus quis velit condimentum pretium. 
                </div>
            </div>
            <div>
                <div className="tabs-page-cites">
                <header className="columns">
                        <div className="column">
                            <a href="../pages/viveros">
                                <button className="button m-0 p-0 is-Active">
                                    Viveros
                                </button>
                            </a>
     
                        </div>
                        <div className="column">
                             <a href="../pages/zoocriaderos">
                                <button className="button m-0 p-0">
                                    Zoocriaderos
                                </button>
                            </a>
   
                        </div>
                        <div className="column">
                            <a href="../pages/autoridades">
                                <button className="button m-0 p-0">
                                    Autoridades CITES
                                </button>
                            </a>

                        </div>
                        <div className="column">
                            <a href="../pages/especialistas">
                                <button className="button m-0 p-0">
                                    Especialistas y expertos
                                </button>
                            </a>
                        </div>
                    </header>
                    
                    <div className="content-tabs-page-cites mb-5">
                        <div className="columns mt-5 mx-5">
                            <div className="column mx-5">
                            <div className="container">
                                <div className="columns mx-4">
                                    
                                        <div className="column is-4">
                                        <InputsCreate referencia={this.txtExportacion} type="text" placeholder="Buscar por nombre..." id="txtZoocriadero"></InputsCreate> 
                                        </div>
                                        <div className="column is-4">
                                        <InputsCreate byDefault="Pais" type="select" referencia={this.slctPais} forSelect={this.state.listaPaises} ></InputsCreate>
                                        </div>
                                        <div className="column is-4">
                                        <InputsCreate byDefault="Tipo"type="select" referencia={this.slctTipo} forSelect={this.state.listaTipo} ></InputsCreate>
                                        </div>
                                    </div>
                                <div className="columns">
                                    <div className="column">
                                    <table className="table table-cites" id="tblPaises">
                                            <thead>
                                                <tr>
                                                    <th>
                                                    Nro.
                                                    </th>
                                                    <th>
                                                    Nombre/Razón social
                                                    </th>
                                                    <th>
                                                    País
                                                    </th>
                                                    <th>
                                                    Especies
                                                    </th>
                                                    <th>
                                                    Cantidad Total
                                                    </th>
                                                </tr>
                                               

                                                
                                            </thead>
                                            <tbody>


                                            </tbody>
                                        </table>
                                    </div>
                                        
                                </div>
                            
                            </div>
                            </div>
                           

                        </div>
                    </div>
                </div>
               
                
            </div>

        </div>
        )
    }
}

export default connect(null, {set_datapage})(Viveros)